// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tab-element:not(.filter)>:first-child{margin-top:16px}.tab-element:not(.filter)>:last-child{margin-bottom:32px}.tab-element:not(.filter)>*+*{margin-top:32px}.tab-element:not(.filter)>[class*=\" bg-\"]:not(.bg-white):not(.bg-transparent),.tab-element:not(.filter)>[class^=bg-]:not(.bg-white):not(.bg-transparent){padding-bottom:64px;padding-top:64px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
